// src/theme/palette.ts
import { colors, darken, lighten } from "@mui/material";

// Extend the Palette interface
declare module "@mui/material/styles" {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Palette {
    borderColor: {
      dark: string;
    };
    tabs: {
      hover: string;
      selected: string;
    };
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface PaletteOptions {
    borderColor?: {
      dark?: string;
    };
    tabs?: {
      hover?: string;
      selected?: string;
    };
  }
}

const white = "#FFFFFF";
const black = "#030f0d";
const brand = "#00B977";

const palette = {
  action: {
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    hover: "rgba(0, 185, 119, 0.12)",
    selected: "rgba(0, 185, 119, 0.20)",
  },
  background: {
    default: "#F3F5F2",
    paper: colors.grey[100],
  },
  // Custom palette fields:
  borderColor: {
    dark: "#DEE2E5",
  },
  common: {
    black,
    white,
  },
  contrastThreshold: 3,
  divider: colors.grey[600],
  error: {
    dark: colors.red[900],
    light: colors.red[600],
    main: colors.red[800],
  },
  info: {
    dark: colors.blue[900],
    light: colors.blue[400],
    main: colors.blue[600],
  },
  primary: {
    dark: darken(brand, 0.35),
    light: "#00EF99",
    main: brand,
  },
  secondary: {
    dark: "#000",
    light: lighten(black, 0.15),
    main: black,
  },
  success: {
    dark: colors.green[900],
    light: colors.green[400],
    main: colors.green[600],
  },
  tabs: {
    hover: "rgba(52, 50, 50, 0.04)",
    selected: "rgba(52, 50, 50, 0.08)",
  },
  text: {
    disabled: "rgba(0, 0, 0, 0.38)",
    primary: black,
    secondary: colors.grey[600],
  },
  tonalOffset: 0.6, // tonal Offset > 0.6 will generate out of range error
  warning: {
    dark: colors.orange[800],
    light: colors.orange[400],
    main: colors.orange[600],
  },
} as const;

export default palette;
